export default "__VITE_ASSET__Dpea2tyq__"